module.exports = __webpack_public_path__ + "img/23.c438b09e.jpeg";